import type { GeneratedContent } from "../types";

interface EssayQuestionsProps {
  content: GeneratedContent;
}

export const EssayQuestions: React.FC<EssayQuestionsProps> = ({ content }) => {
  const questoes = content.estrutura_avaliacao?.questoes_dissertativas;

  if (!questoes || !questoes.exemplos || questoes.exemplos.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      <h3 className="section-title text-lg font-bold text-indigo-900 mb-6 pb-3 border-b-2 border-indigo-700">
        Parte II - Questões Dissertativas
      </h3>

      {questoes.exemplos.map((questao: any, idx: number) => (
        <div key={idx} className="question-block mb-8">
          <p className="font-semibold text-gray-900 mb-4">
            <span className="bg-indigo-100 text-indigo-900 px-3 py-1 rounded-full mr-2">
              {questao.numero}
            </span>
            {questao.enunciado}
            <span className="text-indigo-700 font-bold ml-2">
              ({questao.valor} pontos)
            </span>
          </p>
          <div className="answer-space border-2 border-dashed border-gray-300 rounded p-4 min-h-[100px] bg-gray-50">
            <p className="text-gray-400 text-sm">Espaço para resposta</p>
          </div>
        </div>
      ))}
    </div>
  );
};
